import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { detect } from "detect-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Document, Page } from "react-pdf/dist/entry.webpack";
import "react-pdf/dist/Page/AnnotationLayer.css";
import Button from "../button/Button";
import {
  ModalWrapper,
  Modal,
  Header,
  CloseButton,
  Body,
  Footer,
} from "./styles/cv-modal-styles";

class CvModal extends Component {
  state = {
    numPages: null,
    data: null,
  };

  componentDidMount() {
    const { pdfUrl } = this.props;

    axios.get(pdfUrl).then(({ data }) => {
      this.setState({ data });
    });
  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  };

  handleDownloadCv = (e, cvDownloadPath) => {
    e.preventDefault();
    window.location.href = cvDownloadPath;
  };

  render() {
    const { toggleModal, cvDownloadPath } = this.props;
    const { numPages, data } = this.state;
    const iOS = detect().name === "ios";

    return (
      <ModalWrapper>
        <Modal iOS={iOS}>
          <Header>
            <CloseButton onClick={toggleModal}>
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          </Header>
          <Body>
            <Document file={data} onLoadSuccess={this.onDocumentLoad}>
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  className="cv__canvas--unset-height"
                />
              ))}
            </Document>
          </Body>
          <Footer>
            <Button
              buttonName="Download"
              secondary
              onClickAction={(e) => this.handleDownloadCv(e, cvDownloadPath)}
            />
          </Footer>
        </Modal>
      </ModalWrapper>
    );
  }
}

CvModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  cvDownloadPath: PropTypes.string.isRequired,
  pdfUrl: PropTypes.string.isRequired,
};

export default CvModal;
